import { alertMessageDeleteAddressHappy, alertMessageDeleteAddressHappyEmpty } from "@/happyTheme/event/dashboard/address/alertMessageDeleteAddressHappy"
import { TimeOutClass } from "@/happyTheme/services/timeout/TimeOutClass"
import { AddressService } from "@/services/AddressService"
import type { Ref } from "vue"

export async function deleteAddressHappy(isVisible: Ref<boolean>) {
    const addressId = alertMessageDeleteAddressHappy.value.city.address_id
    if (!addressId) return

    const addressService = new AddressService()
    const res = await addressService.deleteAddress(addressId)

    if (res.class === 'success') {
        const idTimeOut = setTimeout(() => {
            isVisible.value = false
            setTimeout(() => {
                alertMessageDeleteAddressHappy.value = alertMessageDeleteAddressHappyEmpty
            }, 200)
        }, 1500)
        const timeOut = TimeOutClass.getInstance()
        timeOut.setIdTimeout(idTimeOut)
    }

    return res
}